import { useRef } from 'react';

export const UseUploadModal = () => {
  const itemsRef = useRef();

  return [itemsRef];
};
